import * as angular from "angular";
import { Constants as constants } from "@constants/shared";
import { OnboardingRepo as OnboardingRepo } from "@services/onboarding.repo";
import { clientApplication } from "./clientApplication";
import { clientInfo } from "./viewClient/clientInfo.modal"

export const clientApplicationModule = "clientapplication";

angular
  .module(clientApplicationModule, [
    "ui.router",
    "dataGrid",
    "pagination",
    "angular-loading-bar",
    "angularModalService"
  ])
  .constant("config", constants.Default)
  .service("onboardingRepo", OnboardingRepo)
  .component("clientapplication", clientApplication)
  .component("clientInfoModal", clientInfo);




// WEBPACK FOOTER //
// ./src/app/onboarding/clientapplication.index.ts